<!-- 退款/售后 -->
<template>
	<div class="wrap">

		<Header backgroundColor="#F2F2F2"></Header>

		<Subheader hideAlert="true" :hide="true" :hide2="true" :hideStep="true" :stepNum="4"></Subheader>

		<div class="box">
			<p class="top-row">
				<span>商品</span>
				<span>单价</span>
				<span>数量</span>
				<span>交易操作</span>
			</p>
			<div class="center-module">
				<div class="product-module">
					<div style="width: calc(100% - 174px);">
						<div  v-for="(goods, index) in orderInfo.order_item" :key="index" style="display: flex; flex-wrap: wrap; padding: 5px 0;">
							<div class="product-msg-box">
								<img :src="goods.cover" class="product-img">
								<div class="product-msg-sidebar">
									<p class="product-name">{{goods.name}}</p>
									<p class="product-msg" v-for="(item2, index2) in goods.goods_spec_arr" :key="index2">{{item2[0]}}：{{item2[1]}}</p>
									<!-- <p class="product-msg-red">支持7天无理由退换货</p> -->
								</div>
							</div>
							<div class="item-msg-box">
								￥{{goods.sell_price}}
							</div>
							<div class="item-msg-box">
								{{goods.num}}
							</div>
						</div>
					</div>
					<div class="item-msg-box">
						<!-- 退款关闭显示 -->
						<span v-if="refundInfo.status == 5">退款关闭</span>
						<!-- 退款成功显示 -->
						<span v-if="refundInfo.status == 3" class="red">退款成功</span>
					</div>
				</div>
			</div>
			<div class="bottom-module">
				<p class="bottom-label">退款信息</p>
				<div class="bottom-box">
					<p class="bottom-row">
						<span>退款原因:</span>{{refundInfo.apply_case}}
					</p>
					<!-- 退款关闭这个金额是黑色，退款成功这个金额是红色字体， -->
					<p class="bottom-row">
						<span>退款金额:</span><span class="red">￥{{orderInfo.price_total}}</span>
					</p>
					<p class="bottom-row">
						<span>申请件数:</span>{{orderInfo.goods_num}}
					</p>
					<p class="bottom-row">
						<span>申请时间:</span>{{refundInfo.create_at}}
					</p>
					<p class="bottom-row">
						<span>退款编号:</span>{{refundInfo.refund_no}}
					</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Subheader from '../../components/sub-header.vue';
	import { orderGetOrderDetail, orderGetRefundInfo } from '../../service/service';
	export default {
		components: {
			Header,
			Subheader
		},
		data() {
			return {

				// 订单详情
				orderInfo: {
					id: 0
				},

				// 退款单详情
				refundInfo: {},
			};
		},
		mounted() {
			const option = this.$route.query;
			const id =  parseInt(option.id || 0);
			if (id > 0) {
				this.orderInfo.id = id;
				this.getOrderDetail();
			}
		},
		methods: {

			// 获取退款详情
			getRefundInfo() {
				orderGetRefundInfo({ order_id: this.orderInfo.id }).then(({code, msg, data}) => {
					if (code == 1) {
						this.refundInfo = data.detail;
						this.refundExpressParams.id = data.detail.id;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 订单详情
			getOrderDetail() {
				orderGetOrderDetail({ order_id: this.orderInfo.id }).then(({ code, msg, data }) => {
					if (code == 1) {
						data.detail.order_item = data.detail.order_item.map(item => ({
							...item,
							['goods_spec_arr']: item.goods_spec.split(';;').map(str => str.split('::')),
						})),
						this.orderInfo = data.detail;
						if (this.orderInfo.refund_state > 0) {
							this.getRefundInfo();
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 140px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.box {
		width: 1200px;
		display: flex;
		flex-direction: column;
		margin: 20px 0;
	}

	.top-row {
		width: 100%;
		height: 100px;
		background-color: #F9F9F9;
		border-radius: 8px 8px 0 0;
		display: flex;
		align-items: center;
		color: #111111;
		font-size: 20px;
		font-weight: bold;
	}

	.top-row>span:first-child {
		width: 656px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.top-row>span {
		width: 174px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.center-module {
		width: 100%;
		background-color: #FFFFFF;
		border-radius: 0 0 8px 8px;
		display: flex;
		flex-direction: column;
		padding: 34px 0;
	}

	.product-module {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 38px;
	}

	.product-module:last-child {
		margin-bottom: 0;
	}

	.product-msg-box {
		width: 656px;
		display: flex;
		align-items: flex-start;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.product-img {
		width: 151px;
		height: 151px;
		border-radius: 6px;
		object-fit: cover;
		margin-right: 20px;
	}

	.product-msg-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.product-name {
		width: 50%;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #000000;
		font-size: 16px;
		margin-bottom: 7px;
	}

	.product-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #666666;
		font-size: 17px;
	}

	.product-msg-red {
		width: 100%;
		color: #F2501A;
		font-size: 14px;
		line-height: 14px;
		margin-top: 7px;
	}

	.item-msg-box {
		width: 174px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 50px 20px 0;
		box-sizing: border-box;
		color: #111111;
		font-size: 16px;
	}

	.item-msg-box>span {
		margin-bottom: 6px;
	}

	.item-msg-box>span:last-child {
		margin-bottom: 0;
	}

	.bottom-module {
		width: 100%;
		background-color: #FBFBFB;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		margin: 10px 0;
	}

	.bottom-label {
		width: 100%;
		height: 34px;
		line-height: 34px;
		display: flex;
		align-items: center;
		padding: 0 11px;
		box-sizing: border-box;
		color: #111111;
		font-size: 14px;
		border-radius: 8px 8px 0 0;
		background-color: #E6E6E6;
	}

	.bottom-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 11px;
		box-sizing: border-box;
	}

	.bottom-row {
		width: 100%;
		display: flex;
		align-items: center;
		color: #000000;
		font-size: 13px;
		margin-bottom: 10px;
	}

	.bottom-row:last-child {
		margin-bottom: 0;
	}

	.bottom-row>span {
		margin-right: 22px;
		color: #777777;
		font-size: 14px;
	}

	.red {
		color: #F2501A !important;
	}

	.sub-item-btn {
		color: #111111;
		font-size: 12px;
		margin-bottom: 6px;
	}

	.sub-item-btn:last-child {
		margin-bottom: 0;
	}

	.sub-item-btn.border {
		border: 1px solid #F2501A;
		border-radius: 8px;
		width: 78px;
		height: 31px;
		line-height: 31px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #F2501A;
		font-size: 12px;
	}
</style>
